import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => {
  return ({
    headerWrapper: {
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '24px 40px',
      height: '100%'
    },
    title: {
      color: '#335977',
      fontSize: '30px',
      fontWeight: 'bold'
    },
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start'
    },
    stepperContainer: {
      boxShadow: '0px 2px 10px #3F434714',
      margin: '24px 40px',
      padding: '1px 20px 20px',
    },
    formContainer: {
      boxShadow: '0px 2px 10px #3F434714',
      margin: '24px 40px',
      padding: '20px'
    },
    formHeading: {
      color: '#F37320',
      backgroundColor: '#F7F7F7',
      fontSize: '14px',
      fontWeight: 600,
    },
    formSubheading: {
      color: '#939497',
      fontSize: '12px'
    },
    formInput: {
      maxWidth: 500
    },
    enchargeValueWrapper: {
      width: '30px',
      textAlign: 'center'
    },
    formPaper: {
      width: '30%',
      maxWidth: '220px',
      minWidth: '180px',
      margin: '20px 10px',
      minHeight: '200px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      border: '1px dashed #70707089',
      opacity: 1,
      backgroundColor: '#F5F5F5',
      padding: '15px 20px'
    },
    mb20: {
      marginBottom: '20px'
    },
    uploadInput: {
      display: 'none',
    },
    uploadText: {
      color: '#545456',
      fontWeight: 800,
      fontSize: '12px',
      textAlign: 'center'
    },
    uploadButton: {
      textAlign: 'center',
      minHeight: '36px'
    },
    uploadHelperText: {
      color: '#545456',
      fontSize: '12px',
      textAlign: 'center'
    },
    adornmentIcons: {
      backgroundColor: '#F3731F',
      color: '#FFFFFF',
      borderRadius: 5,
    },
    disabledButton: {
      backgroundColor: '#70707033',
      color: '#9F9E9E',
      borderRadius: 5,
    },
    fileName: {
      margin: '2px 0 5px 0',
      fontSize: '12px',
      textAlign: 'center',
      color: '#F37320',
      wordBreak: 'break-all'
    },
    error: {
      color: '#d32f2f',
      fontSize: '0.75rem'
    },
    center: {
      textAlign: 'center',
      wordBreak: 'break-all'
    },
    modalText: {
      color: '#565657',
      fontSize: '20px',
      fontWeight: 600,
      textAlign: 'center',
      marginBottom: '2rem'
    },
    modalButton: {
      maxWidth: '150px',
    },
    checkboxLabel: {
      fontWeight: 'bold',
      fontSize: '16px',
      color: '#545455',
      opacity: '100%'
    },
    links: {
      color: '#ff8c00',
      textDecoration: 'none'
    },
    lists: {
      marginTop: '0px'
    },
    formCheckboxLabel: {
      fontSize: '14px',
      marginBottom: '10px',
      marginLeft: '10px',
      color: '#000000',
      opacity: '100%',
      lineHeight: 1.5
    },
    fileEdit: {
      cursor: 'pointer'
    },
    downloadIcon: {
      verticalAlign: 'middle',
      marginRight: '5px',
      width: '18px',
    },
    fileModalText: {
      fontSize: '14px',
      color: '#565657'
    },
    fileModalIcon: {
      cursor: 'pointer'
    },
    customPaper: {
      maxWidth: '700px'
    },
    customPopper: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: `0px 6px 12px #0000002E`,
      fontSize: 11,
    },
    customPopperText: {
      color: '#4A4A4A',
      opacity: 0.7,
      padding: '8px'
    },
    paper: {
      maxHeight: '200px',
      overflowY: 'auto',
      minWidth: '250px',

      '&::-webkit-scrollbar': {
        width: '5px'
      },

      '&::-webkit-scrollbar-thumb': {
        borderRadius: '3px',
        backgroundColor: '#c3c3c3',
        width: '5px'
      }
    },
    dateWrapper: {
      display: 'flex',
      justifyContent: 'end',
      maxWidth: '500px',
      position: 'relative'
    },
    customArrowIcon: {
      marginRight: '15px'
    },
    enchargeFieldWrapper: {
      border: '0.5px solid #707070',
      paddingLeft: '10px'
    },
    utilityInput: {
      width: 0
    }
  })
})

export { useStyles }
